<template>
	<div id="app">
		<Main />
	</div>
</template>

<script>
import Main from './components/Main.vue'

export default {
	name: 'app',
	components: {
		Main
	}
}
</script>

<style>

body {
	background-color: rgb(202, 201, 206);
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	height: 100%;
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 60px;
}
</style>
